<template>
  <v-container fluid>
    <v-layout child-flex>
      <v-flex>
        <v-data-table
          :headers="headers"
          :items="activeTransactions"
          :pagination.sync="pagination"
          :rows-per-page-items="pageCountOptions"
          item-key="id"
          class="elevation-0 installments"
          expand
          no-data-text="No data found"
          no-results-text="No results found"
          must-sort
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.value"
                :class="['font-weight-bold text-xs-center column sortable pa-0', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)"
                v-if="header.value !== 'card_expiration_yymm' || (header.value === 'card_expiration_yymm' && schedule.request_type !== 'ach')"
              >
              <div class="pl-3" v-if="header.sortable">
                {{ header.text }}
                <v-icon small pa-0>arrow_upward</v-icon>
              </div>
              <div v-else>
                {{ header.text }}
              </div>
              </th>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <tr class="hover-table">
              <td class="text-xs-center">{{ dateFromUtc(props.item.authorized) }}</td>
              <td class="text-xs-center">
                <span v-if="props.item.tracking_id">{{ props.item.tracking_id || '-' }}</span>
                <span class="text--disabled" v-else>-</span>
              </td>
              <td class="text-xs-center">
                <div v-if="props.item.request_type === 'achcredit' || props.item.request_type === 'credit'">
                  <v-chip small outline color="info"><v-icon small class="mr-1">fa-undo</v-icon>Refund</v-chip>
                </div>
                <v-chip small outline color="primary" v-else-if="props.item.request_type === 'ach' || props.item.request_type === 'sale'"><v-icon small class="mr-1">fa-dollar</v-icon>Sale</v-chip>
                <v-chip small outline v-else-if="props.item.is_pending_recurring"><v-icon small class="mr-1">fa-clock-o</v-icon>Pending Sale</v-chip>
                <v-chip small outline color="error" v-else-if="props.item.request_type === 'achvoid' || props.item.request_type === 'void'"><v-icon small class="mr-1">fa-ban</v-icon>Void</v-chip>
                <div v-else>-</div>
              </td>
              <td class="text-xs-center">
                <template v-if="props.item.request_type !== 'void' && props.item.request_type !== 'achvoid'">
                  {{ money(props.item.total_amount / 100) }}
                </template>
                <span v-else>-</span>
              </td>
              <td class="text-capitalize text-xs-center">
                <v-chip small outline color="grey" v-if="props.item.voided"><v-icon small class="mr-1">fa-ban</v-icon>Voided</v-chip>
                <v-chip small outline color="info" v-else-if="props.item.refunded"><v-icon small class="mr-1">fa-undo</v-icon>Refunded</v-chip>
                <v-chip small outline color="orange" v-else-if="!props.item.settled && props.item.response_code === '000' && props.item.response_text === 'PENDING'"><v-icon small class="mr-1">fa-clock-o</v-icon>Pending</v-chip>
                <v-chip small outline color="success" v-else-if="!props.item.settled && props.item.response_code === '000'"><v-icon small class="mr-1">fa-check</v-icon>Approved</v-chip>
                <v-chip small outline color="success" v-else-if="props.item.settled && props.item.response_code === '000'"><v-icon small class="mr-1">fa-check-circle</v-icon>Settled</v-chip>
                <v-chip small outline v-else-if="props.item.is_pending_recurring"><v-icon small class="mr-1">fa-clock-o</v-icon>Pending</v-chip>
                <v-chip small outline color="error" v-else><v-icon small class="mr-1">fa-times-circle</v-icon>Declined</v-chip>
              </td>
              <td class="text-xs-center">{{ props.item.settled ? dateFromUtc(props.item.settled) : '-' }}</td>
              <td class="text-xs-center">
                <span v-if="props.item.user_id"><v-chip small outline><v-icon small class="mr-1">person</v-icon>Manual</v-chip></span>
                <span v-else-if="props.item.is_pending_recurring">-</span>
                <span v-else><v-chip small outline><v-icon small class="mr-1">computer</v-icon>System</v-chip></span>
              </td>
              <td class="text-xs-center">{{ props.item.last_four || '-' }}</td>
              <td class="text-xs-center" v-if="schedule.request_type !== 'ach'">
                <div>{{ props.item.card_expiration_yymm ? expiration(props.item.card_expiration_yymm) : '-' }}</div>
              </td>
              <td class="text-xs-center">
                <template v-if="!props.item.is_pending_recurring">
                  <ReceiptModal :transaction="props.item" />
                </template>
                <template v-else>-</template>
              </td>
              <td class="text-xs-center">
                <div class="px-1">
                <template v-if="!props.item.is_pending_recurring && !(props.item.request_type === 'achvoid' || props.item.request_type === 'void' || props.item.request_type === 'achcredit' || props.item.request_type === 'credit')">
                  <VoidModal :transaction="props.item" v-if="!props.item.settled && !props.item.voided && props.item.response_code === '000'" />
                  <RefundModal :transaction="props.item" v-if="props.item.settled && !props.item.refunded && !props.item.voided && props.item.response_code === '000'" />
                  <span class="text--disabled" v-if="props.item.voided || props.item.refunded">N/A</span>
                </template>
                <template v-else>
                  <span class="text--disabled">N/A</span>
                </template>
                </div>
              </td>
              <td class="text-xs-center" v-if="hasFapsMigration">
                <v-chip small outline :color="props.item.processor === 'FAPS' ? 'orange' : 'primary'">{{ props.item.processor || 'PNX' }}</v-chip>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            No data found
          </template>

          <template slot="actions-prepend">
            <v-radio-group class="justify-start" v-model="settledOnly" row hide-details label="Filter Transactions: ">
              <v-radio
                color="black"
                key="salesTransactions"
                label="Show Settled"
                :value="true"
                hide-details
              />
              <v-radio
                color="black"
                key="allTransactions"
                label="Show All"
                :value="false"
                hide-details
              />
            </v-radio-group>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Moment from 'moment'

import Bus from '@/bus'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import RecurringMixin from '@/mixins/recurring'
import StoreMixin from '@/store/mixin'
import UtilityMixin from '@/mixins/utility'

import ReceiptModal from '@/components/transactions/ReceiptModal.vue'
import RefundModal from '@/components/transactions/RefundModal.vue'
import VoidModal from '@/components/transactions/VoidModal.vue'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, RecurringMixin, StoreMixin, UtilityMixin],
  components: {ReceiptModal, RefundModal, VoidModal},

  data: function () {
    return {
      settledOnly: false,
      showFeeForRow: {},
      pagination: {
        sortBy: 'authorized',
        descending: false,
        page: 1,
        rowsPerPage: 12,
        totalItems: 0
      },
      pageCountOptions: [12, 24, 48, {text: 'All', value: -1}]
    }
  },

  props: {
    schedule: Object,
    paymentHistory: Array,
    fapsTransactions: {
      type: Array,
      default: function () { return [] }
    },
    downpaymentTransaction: {
      type: Object,
      default: function () { return {} }
    },
    futurePendingPayments: {
      type: Array,
      default: function () { return [] }
    }
  },

  beforeDestroy () {
    Bus.$off('closeOptionsModal', this.reload)
  },

  mounted () {
    Bus.$on('closeOptionsModal', this.reload)
  },

  computed: {
    hasFapsMigration () {
      return this.fapsTransactions && this.fapsTransactions.length > 0 && this.hasPermission('can_view_migration')
    },

    headers () {
      let cols = [
        { value: 'authorized', text: 'Date', sortable: true, align: 'center' },
        { value: 'tracking_id', text: 'Transaction ID', sortable: true, align: 'center' },
        { value: 'transaction_type', text: 'Type', sortable: true, align: 'center' },
        { value: 'total_amount', text: 'Amount', sortable: true, align: 'center' },
        { value: 'transaction_status', text: 'Status', sortable: true, align: 'center' },
        { value: 'settled', text: 'Settled', sortable: true, align: 'center' },
        { value: 'user_id', text: 'Initiation', sortable: true, align: 'center' },
        { value: 'last_four', text: 'Last Four', sortable: true, align: 'center' },
        { value: 'card_expiration_yymm', text: 'Expiration', sortable: true, align: 'center' },
        { value: 'receipt', text: 'Receipt', align: 'center', sortable: false },
        { value: 'actions', text: 'Actions', align: 'center', sortable: false }
      ]
      if (this.hasFapsMigration) {
        cols.push({ value: 'processor', text: 'Processor', sortable: true, align: 'center' })
      }
      return cols
    },

    activeTransactions: function () {
      let trans = []
      const uniqueKeys = new Set()

      const addUnique = (item) => {
        let key = item.id ? `${item.processor || 'PNX'}_${item.id}` : `future_${item.authorized}`
        if (!uniqueKeys.has(key)) {
          uniqueKeys.add(key)
          trans.push(item)
        }
      }

      const paymentTypes = ['sale', 'credit', 'ach', 'achcredit', 'void', 'achvoid']
      const fapsAddedTrackingIds = new Set()

      if (this.fapsTransactions && this.fapsTransactions.length) {
        this.fapsTransactions.forEach(tran => {
          if (!paymentTypes.includes(tran.request_type)) return

          if (tran.associatedTransactions && tran.associatedTransactions.length) {
            tran.associatedTransactions.forEach(child => {
              if (paymentTypes.includes(child.request_type)) {
                addUnique(Object.assign({}, child, {
                  authorized: child.future_post || child.authorized,
                  is_pending_recurring: !!child.future_post,
                  processor: child.processor_name === 'fpg' ? 'FAPS' : 'PNX'
                }))
                if (child.tracking_id) fapsAddedTrackingIds.add(child.tracking_id)
              }
            })
          }

          if (tran.authorized) {
            addUnique(Object.assign({}, tran, {
              authorized: tran.future_post || tran.authorized,
              is_pending_recurring: !!tran.future_post,
              processor: tran.processor_name === 'fpg' ? 'FAPS' : 'PNX'
            }))
            if (tran.tracking_id) fapsAddedTrackingIds.add(tran.tracking_id)
          }
        })
      }

      if (this.paymentHistory && this.paymentHistory.length) {
        this.paymentHistory.forEach(row => {
          if (row.tracking_id && fapsAddedTrackingIds.has(row.tracking_id)) return
          if (!paymentTypes.includes(row.request_type)) return
          addUnique(Object.assign({}, row, {
            authorized: row.scheduled_at || row.created || row.authorized,
            processor: 'PNX'
          }))
        })
      }

      if (this.futurePendingPayments && this.futurePendingPayments.length && this.schedule.recurring_status !== 'cancelled' && this.schedule.recurring_status !== 'ended') {
        this.futurePendingPayments.forEach(payment => {
          addUnique({
            authorized: Moment(payment.date).format('YYYY-MM-DDTHH:mm:ssZ'),
            is_pending_recurring: true,
            total_amount: payment.total_amount,
            fee_amount: payment.fee_amount,
            tracking_id: '',
            response_code: '000',
            response_text: 'PENDING',
            voided: null,
            settled: null,
            refunded: null,
            last_four: payment.last_four || this.schedule.last_four,
            processor: 'PNX'
          })
        })
      }

      const filtered = this.filterSettledOnly(trans)
      return this.sortTransactions(filtered)
    }
  },

  methods: {
    reload () {
      Bus.$emit('reloadPnxInstallment')
    },

    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },

    filterSettledOnly (trans) {
      if (this.settledOnly) {
        return trans.filter(t => (t.request_type === 'sale' || t.request_type === 'ach') && t.settled)
      }
      return trans
    },

    sortTransactions (trans) {
      if (this.pagination.sortBy === 'authorized') {
        if (this.pagination.descending) {
          trans.sort((a, b) => (Moment(a.authorized).isBefore(b.authorized)) ? 1 : -1)
        } else {
          trans.sort((a, b) => (Moment(a.authorized).isAfter(b.authorized)) ? 1 : -1)
        }
      } else {
        if (this.pagination.descending) {
          trans.sort((a, b) => (a[this.pagination.sortBy] < b[this.pagination.sortBy] ? -1 : 1))
        } else {
          trans.sort((a, b) => (a[this.pagination.sortBy] > b[this.pagination.sortBy] ? -1 : 1))
        }
      }
      return trans
    }
  }
}
</script>

<style lang="less" scoped>
  .installments table.v-table tbody {
    outline: 1px solid var(--v-primary-base);
  }

  .installments table.v-table td {
    background-color: #f4f4f4;
    outline: 2px solid white;
    padding: 0 !important;
  }

  .installments .v-datatable__actions {
    border-top: 1px solid var(--v-primary-base) !important;
    margin-top: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pnxInstallments/Schedule.vue